<template>
  <div>
    <layout
      licenseTypeName="网络版"
      licenseType="Network"
      :amount="calcRes.amount"
      :originalAmount="calcRes.originalAmount"
      @submit="handleSave"
      @buyVersion="handleBuyVersion"
      :loadingCalc="loadingCalc"
      :loadingSubmit="loadingSubmit"
    >
      <!-- -----------------------------------------------购买明细插槽------------------------------------------------------------ -->
      <template v-slot:center>
        <!-- style=" max-height: 62vh; overflow-y: scroll;" -->
        <div>
          <div v-loading="loading" class="my-m-t-20">
            <!-- 套餐列表 -->
            <div class="box-wrap" :style="{paddingTop:'10px'}">
              <div
                :class="['box-item',currentPackage.id == item.id ? 'box-item-active':'']"
                v-for="(item,index) in packageList"
                :key="index"
                @click="handlePackage(item)"
              >
                <div>{{item.title}}</div>
                <div class="my-flex my-row-center">
                  <div style="color:#F56C6C">￥</div>
                  <div class="amount" style="font-weight: bold; font-size: 16px; padding: 15px 0;color:#F56C6C">{{item.price.toFixed(0)}}</div>
                  <div class="my-m-l-5" style="color:#E6A23C">{{ item.freeDesc }}</div>
                </div>
                <div class="original">原价￥{{item.originalPrice}}</div>
                <div class="tips" v-if="item.tag">{{item.tag}}</div>
                <div
                  v-if="item.time"
                  class="my-font-xs my-text-center"
                  style="position: absolute; left: 0; bottom:0; width: 100%;background: linear-gradient(to right, #FE8B16, #ff533c) ; padding: 2px 0; color: #fff; border-radius: 0 0 5px 5px;"
                >{{ item.time }}</div>
              </div>
              <!-- 其他套餐 -->
              <div
                class="box-item"
                style="display: flex; align-items: center; justify-content: center; color: #999; cursor: pointer; height: 118px;"
                @click="handleBuyOther"
              >其它套餐</div>
            </div>
          </div>
        </div>
      </template>
    </layout>

    <pay-dialog :no="no" :amount="calcRes.amount" ref="payDialog" @confirm="confirmPay" />

    <login-dialog ref="loginDialog" @confirm="loginConfirm" />
    <ask-dialog ref="askDialog" @confirm="askConfirm" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
import API from '@/api/order'
import API_Soft from '@/api/soft'
import API_User from '@/api/user'
import API_Book from '@/api/book'
import layout from './components/_layout.vue'
import payDialog from './components/payDialog.vue'
import loginDialog from '@/_myComponents/LoginDialog/index.vue'
import askDialog from './components/askDialog'

export default {
  components: {
    layout,
    payDialog,
    loginDialog,
    askDialog
  },
  name: 'BuyNetwork',
  data() {
    return {
      loading: false,
      loadingCalc: false,
      loadingSubmit: false,
      bookInfo: {
        id: '',
        name: '',
        company: '',
        tenantId: '',
        tenantVersion: ''
      },
      currentPackage: {},

      packageList: [],

      calcRes: {
        amount: 0,
        originalAmount: 0
      },

      currentBuyPackage: {
        price: 0,
        originalPrice: 0
      },

      no: '',
      calcResData: { amount: 0, originalAmount: 0 }
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice']),
    isLogin() {
      return getToken()
    }
  },
  mounted() {},
  beforeDestroy() {
    this.packageList.forEach(item => {
      clearInterval(item.timer)
    })
  },
  created() {
    console.log('buyPackage this.$route.query', this.$route.query)

    //提前加载数据
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())

    // 如果传过来bookId  证明已经登陆过
    if (this.$route.query.bookId) {
      //为指定账本购买
      API_Book.getInfo({ id: this.$route.query.bookId }).then(res => {
        this.bookInfo = res.data
        console.log('this.bookInfo', this.bookInfo)

        //获取版本列表
        this.getVersionList()
        //获取沟通套餐列表
        this.getPackageList()
      })
    } else {
      //当前有登录状态
      if (this.isLogin) {
        //获取userInfo
        API_User.getInfo({ refresh: true }).then(res => {
          this.$store.dispatch('dataCache/setUserInfo', res.data)
          this.bookInfo = this.common.getBookInfoFromUserInfo(res.data)
          console.log('API_User.getInfo this.bookInfo', this.bookInfo)
        })
      } else {
        //当前未登录， 提交订单时 或者购买套餐时 在登陆
      }
      //获取沟通套餐列表
      this.getPackageList()
    }
  },
  methods: {
    //提交订单，登录成功后回调
    loginConfirm(bookId) {
      API_Book.getInfo({ id: bookId }).then(res => {
        this.bookInfo = res.data
        if (this.checkBook(this.bookInfo)) {
          this.handleSave()
        }
      })
    },
    //其他套餐，登录成功后回调
    askConfirm(bookId) {
      API_Book.getInfo({ id: bookId }).then(res => {
        this.bookInfo = res.data
        if (this.checkBook(this.bookInfo)) {
          let url = `/#/buyOther?bookId=${this.bookInfo.id}`
          window.location = url
        }
      })
    },
    //支付成功回调
    confirmPay() {
      window.location.href = this.softPrice.softWebUrl
    },
    //切换套餐
    handlePackage(item) {
      this.currentPackage = item
      this.calcAmount()
    },
    //计算价格
    calcAmount() {
      let obj = {
        product: this.utils.getProductCode(),
        licenseType: 'Network',
        freeCode: '',
        couponId: '',
        tenantAccount: this.isDemo(this.bookInfo.tenantAccount) ? '' : this.bookInfo.tenantAccount,
        buyPackageId: this.currentPackage.id, //购买套餐（未购买过或已过期时）
        details: [],
        from: 'web'
      }
      this.loadingCalc = true
      API.postOrderCalcAmount(obj).then(res => {
        this.loadingCalc = false
        this.calcRes = res.data
      })
    },
    //购买其它套餐
    handleBuyOther() {
      if (!this.bookInfo.id) {
        this.$refs.askDialog.open()
        return false
      }
      //如果有账号，直接跳转购买其它套餐
      let url = `/#/buyNetworkOther?bookId=${this.bookInfo.id}`
      window.location = url
    },
    //提交订单（购买套餐）
    handleSave() {
      if (!this.bookInfo.id || this.isDemo(this.bookInfo.tenantAccount)) {
        this.$refs.loginDialog.open()
        return false
      }
      this.loadingSubmit = true
      let obj = {
        from: 'Web',
        product: this.utils.getProductCode(),
        licenseType: 'Network',
        couponId: '',
        tenantAccount: this.bookInfo.tenantAccount,
        buyPackageId: this.currentPackage.id,
        details: []
      }
      API.postOrderCreate(obj).then(res => {
        this.loadingSubmit = false
        this.no = res.data
        this.$refs.payDialog.handleOpen()
      })
    },

    //提交订单（购买版本）
    handleBuyVersion(version) {
      console.log('handleBuyVersion', version)
    },
    //验证bookInfo 的购买状态
    checkBook(info) {
      if (info.tenantVersionStatus == 'Ongoing') {
        this.$Message({
          message: '即将跳转到业务网站，进行续费操作...',
          type: 'success',
          duration: 500
        })
        if (new Date(info.tenantVersionTimeEnd).getFullYear() > 8000) {
          window.location = this.softPrice.softWebUrl + '/appMarket/index'
        } else {
          window.location = this.softPrice.softWebUrl + '/dashboard?buy=true'
        }
        return false
      }
      if (this.isDemo(info.tenantAccount)) {
        this.$Message({
          message: '无法为演示账户购买',
          type: 'warning',
          duration: 500
        })
        return false
      }
      //保存userInfo
      // this.$store.dispatch('dataCache/setUserInfo', info)
      // this.userInfo = info
      return true
    },
    isDemo(account) {
      account = account || ''
      return account.toLowerCase() == 'demo'
    },
    //获取版本列表
    getVersionList() {
      API_Soft.getVersions({
        product: this.utils.getProductCode(),
        licenseType: 'Network'
      }).then(res => {
        this.versionList = res.data.list
        this.diffList = res.data.diffs
        this.introList = res.data.intros
      })
    },
    //获取购买套餐列表
    getPackageList() {
      this.loading = true
      API_Soft.getBuyPackages({
        product: this.utils.getProductCode(),
        version: ''
      }).then(res => {
        this.loading = false
        //列表
        this.packageList = res.data.list
        //优惠倒计时
        this.packageList.forEach(item => {
          item.timer = null
          item.time = ''

          if (
            new Date(item.endTime).getTime() > new Date().getTime() &&
            new Date(item.endTime).getTime() - new Date().getTime() < 30 * 60 * 60 * 24 * 1000
          ) {
            item.timer = setInterval(() => {
              item.time = this.timeHelper.diffSeconds(new Date(), item.endTime)
              if (new Date().getTime() > new Date(item.endTime).getTime()) {
                clearImmediate(item.time)
              }
            }, 1000)
          }
        })
        //默认选中
        let index = res.data.list.findIndex(item => item.id == res.data.defaultPackage)
        if (index >= 0) {
          this.currentPackage = res.data.list[index]
        } else {
          this.currentPackage = res.data.list[0]
        }
        //计算价格
        this.calcAmount()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box-wrap {
  display: flex;
  flex-wrap: wrap;

  .box-item {
    width: 110px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    font-size: 12px;
    line-height: 12px;
    border-radius: 5px;
    color: #262b4b;
    margin: 0 10px 10px 0;
    padding: 25px 0;
    text-align: center;
    position: relative;
    cursor: pointer;

    &:hover {
      // background: linear-gradient(306deg, #ffe0c5, #fff2da);
      border: 1px solid #ffc670;
    }

    &:last-child {
      margin-right: 0;
    }

    .original {
      color: #999;
      text-decoration: line-through;
    }

    .tips {
      position: absolute;
      left: -1px;
      top: -10px;
      z-index: 1000;
      padding: 4px 8px;
      background: linear-gradient(to right, #ffe0c5, #fff2da, #fed6b7);
      border-radius: 10px 10px 10px 0;
      color: #472e09;
    }
  }

  .box-item-active {
    background: linear-gradient(306deg, #fde8d9, #fffbf4);
    border: 2px solid #ffc670 !important;
  }
}

/* ------------------------------------------------------手机版样式------------------------------------------------------ */

@media screen and (max-width: 576px) {
  .box-item {
    width: 98px !important;
    margin: 0 10px 15px 0 !important;
    padding-bottom: 15px !important;
    .amount {
      font-size: 14px !important;
    }
  }
}

::-webkit-scrollbar {
  width: 4px;
  /*对垂直滚动条有效*/
  height: 4px;
  /*对水平滚动条有效*/
}
</style>